// Character Counter Component for form validation
// Used in modals for name/description fields

interface CharacterCounterProps {
  current: number
  max: number
  className?: string
}

export const CharacterCounter = ({ current, max, className = '' }: CharacterCounterProps) => {
  const percentage = (current / max) * 100
  const isWarning = percentage >= 80 && percentage < 100
  const isError = percentage >= 100

  return (
    <span className={ `text-xs ${isError ? 'text-destructive' :
      isWarning ? 'text-amber-500' :
        'text-muted-foreground'
      } ${className}` }>
      { current }/{ max }
    </span>
  )
}

// Common character limits used across the app
// These must match backend validation rules in app/Http/Requests/*
export const CHAR_LIMITS = {
  name: 255,        // matches max:255 in Form/Store, Team/Update, Subaccount/*
  description: 500, // conservative limit (backend allows up to 1000-2000)
  email: 255,       // matches max:255 in Auth/*, Team/*
  shortText: 50,
}
